import React, { createContext, useContext, useMemo } from 'react';
import { useLoadScript } from '@react-google-maps/api';

const GoogleMapsContext = createContext();
const GOOGLE_LIBRARIES = ["places"];

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_PLACES_API_KEY,
    libraries: GOOGLE_LIBRARIES, 
  });

  const value = useMemo(
    () => ({
      isLoaded,
      loadError,
    }),
    [isLoaded, loadError]
  );

  return (
    <GoogleMapsContext.Provider value={value}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error('useGoogleMaps must be used within GoogleMapsProvider');
  }
  return context;
};